import { Infoblock } from '@main/infoblock/const';
import { StateUtils } from '@spartacus/core';

export const INFOBLOCK_FEATURE = 'infoblock';

export interface StateWithInfoblock {
  [INFOBLOCK_FEATURE]: InfoblockState;
}

export interface InfoblockState {
  items: StateUtils.EntityLoaderState<Infoblock[]>;
  closed: string[];
}
